import React, { useState } from "react";
import axios from "axios";
import { CalendarDays } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import PeriodChips from "@/components/PeriodChips";
import { nextPeriodNames } from "@/lib/periodSuggestions";

const API = process.env.REACT_APP_BACKEND_URL;

// Blocking prompt: a school diagnostic must have a named period before answering.
export const PeriodNameGate = ({ diag, headers, onNamed }) => {
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    const label = val.trim();
    if (!label) return;
    setBusy(true);
    try {
      const r = await axios.patch(`${API}/api/diagnostics/${diag.id}`,
        { period_label: label, period_type: diag.period_type === "initial" ? "custom" : diag.period_type },
        { headers });
      toast.success("Diagnostic Period saved");
      onNamed(r.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save the period name");
    } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#0b1220]/60 p-4" role="dialog" aria-modal="true"
      aria-labelledby="period-gate-title" data-testid="period-name-gate">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <div className="flex items-center gap-2 text-[#007a9e]"><CalendarDays className="h-5 w-5" aria-hidden />
          <span className="text-[11px] font-bold uppercase tracking-wider">Required before you continue</span></div>
        <h2 id="period-gate-title" className="mt-2 text-xl font-bold text-[#111827]">Name this Diagnostic Period</h2>
        <p className="mt-1 text-sm text-[#4b5563]">The period name labels your scores, reports and history. Any answers you've already saved are kept.</p>
        <Input id="period-gate-input" autoFocus value={val} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()}
          placeholder="e.g. Fall 2026" className="mt-4 h-11" maxLength={120} data-testid="period-gate-input" />
        <PeriodChips names={nextPeriodNames()} value={val} onPick={setVal} inputId="period-gate-input" testPrefix="period-gate-suggest" />
        <Button onClick={save} disabled={!val.trim() || busy} className="mt-5 h-11 w-full bg-[#007a9e] text-white hover:bg-[#00607d]"
          data-testid="period-gate-save">{busy ? "Saving…" : "Save and continue"}</Button>
        <a href="/diagnostic" className="mt-3 block text-center text-sm font-medium text-[#4b5563] hover:text-[#111827] hover:underline"
          data-testid="period-gate-back">Back to dashboard</a>
      </div>
    </div>
  );
};

export default PeriodNameGate;
